<template>
  <div
    ref="table"
    class="c-table"
    :class="{
      'c-table_scrolled': isScrolled,
      'c-table_scrolled_right': !isScrollEnd && !data.actions && isScroll,
      'c-table_scroll_end': isScrollEnd,
      'c-table_scroll': isScroll,
    }"
  >
    <div
      v-if="displayShadow"
      :class="{
        'c-table__shadow': data.actions,
        'c-table__shadow_active': data.actions,
      }"
    ></div>
    <div v-if="isScroll" class="c-table__scrollbar-wrapper"></div>

    <perfect-scrollbar :ref="'wrapper' + (id !== undefined ? id : '')" class="c-table__wrapper" @scroll="scroll">
      <table ref="container" class="c-table__container">
        <thead ref="header" class="c-table__header">
          <tr v-for="i in levels" :key="i" class="c-table__header-row">
            <th
              v-for="column in getTableColumns(i)"
              :id="`c-table-column-${column.id}`"
              :key="column.id"
              class="c-table__column"
              :style="{ width: column.width ? column.width : '' }"
              :colspan="column.colspan === undefined ? getColspan(column) : column.colspan"
              :rowspan="getRowspan(column)"
              :class="{
                'c-table__column_with_filter': column.type,
                'c-table__column_hidden': isDisabled(column.id),
                'c-table__column_sorted': isSorted(column),
              }"
            >
              <div class="c-table__column-wrapper">
                <div
                  class="c-table__column-label"
                  :class="{
                    'c-table__column-label-children':
                      !isCategory(column) &&
                      sortedColumn &&
                      !(data.type === 'discipline' && column.id === 'explanatory'),
                  }"
                  @click="setSortedColumn(column, sortedColumn)"
                >
                  {{ column.fullName }}
                </div>
              </div>
            </th>
            <th
              v-if="data.actions && i === 1"
              id="c-table-actions-element"
              :rowspan="levels"
              class="c-table__column c-table__column_actions"
            >
              <div class="c-table__column-empty"></div>
            </th>
          </tr>
        </thead>

        <tbody v-for="(group, groupIndex) in sortedRecords" :key="groupIndex" class="c-table__records">
          <tr v-b-toggle="`category-collapse-${id}-${groupIndex}`" class="c-table__record">
            <th
              :style="{
                'border-bottom': sortedRecords.length === groupIndex + 1 ? 'solid 1px #DFE4EF !important' : '',
              }"
              class="c-table__cell__collapse__button"
              :colspan="getTableColumns(levels).length + (data.actions ? 1 : 0)"
            >
              <div class="c-table__cell__collapse__button-wrapper">
                <svg
                  class="c-table__cell__collapse__button__icon"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="11" cy="11" r="10.5" fill="white" stroke="#DFE4EF" />
                  <path
                    d="M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z"
                    fill="#0066FF"
                  />
                  <path
                    d="M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z"
                    fill="#0066FF"
                  />
                </svg>
                <span class="c-table__cell__collapse__button__category__name">
                  {{ group.categoryName }}
                </span>
                <span class="c-table__cell__collapse__button__category__count">
                  {{ group.records.length }}
                </span>
                <c-button-2
                  v-if="group.containsExpiredItem"
                  v-b-popover.html="{
                    id: 'personalEmployeeDocumentsPopover',
                    container: '#app',
                    trigger: 'hover click',
                    content: 'Категория содержит анализы, у которых истек срок годности',
                    placement: 'top',
                  }"
                  class="c-table__cell__collapse__button__button"
                  icon="time-is-out"
                  size="iconic"
                />
                <c-button-2
                  v-if="group.containsExpiringSoonItem"
                  v-b-popover.html="{
                    id: 'personalEmployeeDocumentsPopover',
                    container: '#app',
                    trigger: 'hover blur',
                    content: 'Категория содержит анализы, у которых истекает срок годности',
                    placement: 'top',
                  }"
                  class="c-table__cell__collapse__button__button"
                  icon="expiration-date"
                  size="iconic"
                />
                <div class="c-table__cell__collapse__button__border__right"></div>
              </div>
            </th>
          </tr>

          <b-collapse
            v-for="(record, recordIndex) in group.records"
            v-show="record.isShowRow"
            :id="`category-collapse-${id}-${groupIndex}`"
            :key="recordIndex"
            tag="tr"
            class="c-table__record"
            :class="{
              'c-table__record__red': record.expired,
              'c-table__record__yellow': record.expireSoon,
            }"
            visible
          >
            <template v-if="record.isShowRow">
              <td
                v-for="column in getTableColumns(levels)"
                :key="column.id"
                class="c-table__cell"
                :class="{
                  'c-table__cell_string': column.type === 'string',
                  'c-table__cell_reference': column.type === 'reference',
                  'c-table__cell_number': column.type === 'number',
                  'c-table__cell_date': column.type === 'date',
                  'c-table__cell_hidden': isDisabled(column.id),
                  ['c-table__cell_' + column.id]: column.id,
                }"
              >
                <div class="c-table__cell-value" v-html="record[column.id].value">{{ record[column.id].value }}</div>
              </td>
              <td v-if="data.actions" class="c-table__cell c-table__cell_actions">
                <div class="c-table__cell-actions">
                  <medical-documents-actions-cell
                    :record="record"
                    :record-id="`${groupIndex}-${recordIndex}`"
                    @resendAnalyse="$emit('resendAnalyse', record.analyse_id)"
                    @analyseDeleted="$emit('analyseDeleted', record.analysisId, record.analyse_type.id)"
                  />
                </div>
              </td>
            </template>
          </b-collapse>
        </tbody>
      </table>
    </perfect-scrollbar>

    <div v-if="data.records.length > 0" ref="container" class="c-table__container__mobile">
      <div v-for="(group, groupIndex) in sortedRecords" :key="groupIndex">
        <div
          v-b-toggle="`category-collapse-${id}${groupIndex}`"
          :class="{
            'c-table__cell__collapse__button__hide__borders': groupIndex === 0,
            'c-table__cell__collapse__button__hide__borders__last': sortedRecords.length === groupIndex + 1,
          }"
          class="c-table__cell__collapse__button d-flex align-items-center shadow-none"
        >
          <div class="c-table__cell__collapse__button-wrapper">
            <svg
              class="c-table__cell__collapse__button__icon"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="11" cy="11" r="10.5" fill="white" stroke="#D3D8DF" />
              <path
                d="M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z"
                fill="#0066FF"
              />
              <path
                d="M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z"
                fill="#0066FF"
              />
            </svg>
            <span class="c-table__cell__collapse__button__category__name">{{ group.categoryName }}</span>
            <span class="c-table__cell__collapse__button__category__count">
              {{ group.records.length }}
            </span>
            <c-button-2
              v-if="group.containsExpiredItem"
              v-b-toggle="`category-collapse-${id}${groupIndex}`"
              v-b-popover.html="{
                id: 'personalEmployeeDocumentsPopover',
                container: '#app',
                trigger: 'hover blur',
                content: 'Категория содержит анализы, у которых истек срок годности',
                placement: 'top',
              }"
              class="c-table__cell__collapse__button__button"
              icon="time-is-out"
              size="iconic"
            />
            <c-button-2
              v-if="group.containsExpiringSoonItem"
              v-b-toggle="`category-collapse-${id}${groupIndex}`"
              v-b-popover.html="{
                id: 'personalEmployeeDocumentsPopover',
                container: '#app',
                trigger: 'hover blur',
                content: 'Категория содержит анализы, у которых скоро истечет срок годности',
                placement: 'top',
              }"
              class="c-table__cell__collapse__button__button"
              icon="expiration-date"
              size="iconic"
            />
          </div>
        </div>

        <b-collapse :id="`category-collapse-${id}${groupIndex}`" class="c-table__mobile__collapse" visible>
          <div :id="'tableMobileFixed' + id + groupIndex" class="c-table__container__mobile__fixed__th">
            <table ref="container">
              <template v-for="(column, columnIndex) in getColumns(data.levels)">
                <tr :key="columnIndex" class="c-table__record">
                  <th
                    :class="{ 'c-table__column_sorted': isSorted(column) }"
                    class="c-table__column c-table__column__mobile"
                  >
                    <div
                      class="c-table__column-wrapper c-table__column-wrapper-mobile"
                      @click="setSortedColumn(column, sortedColumn)"
                    >
                      <div class="c-table__column-label">
                        {{ column.label }}
                      </div>
                    </div>
                  </th>
                  <template v-for="(record, recordIndex) in sortedRecords[groupIndex].records">
                    <td
                      :key="recordIndex"
                      class="c-table__cell"
                      :class="{
                        'c-table__cell__red': record[column.id].expired,
                        'c-table__cell__yellow': record[column.id].expireSoon,
                      }"
                    >
                      <div class="c-table__cell-value" v-html="record[column.id].value">
                        {{ record[column.id].value }}
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
              <tr v-if="data.actions" class="c-table__record">
                <th class="c-table__column" :rowspan="levels">
                  <div class="c-table__column-empty c-table__column-empty-mobile"></div>
                </th>
                <td
                  v-for="(record, recordIndex) in sortedRecords[groupIndex].records"
                  :key="recordIndex"
                  class="c-table__cell"
                >
                  <medical-documents-actions-cell
                    :record="record"
                    :record-id="`hidden-${groupIndex}-${recordIndex}`"
                    @resendAnalyse="$emit('resendAnalyse', record.analyse_id)"
                    @analyseDeleted="$emit('analyseDeleted')"
                  />
                </td>
              </tr>
            </table>
          </div>

          <perfect-scrollbar
            :id="'tableMobileScroll' + id + groupIndex"
            :options="{ useBothWheelAxes: false, suppressScrollX: false, suppressScrollY: true }"
            tag="div"
            class="c-table__container__mobile__scrolled__td"
            @scroll="setShadowTableMobile(id + groupIndex)"
          >
            <table ref="container">
              <template v-for="(column, recordIndex) in getColumns(data.levels)">
                <tr v-if="column.colspan === 1" :key="recordIndex" class="c-table__record">
                  <th class="c-table__column c-table__column__mobile">
                    <div class="c-table__column-wrapper c-table__column-wrapper-mobile">
                      <div class="c-table__column-label">
                        {{ column.label }}
                      </div>
                    </div>
                  </th>
                  <template v-for="(record, recordIndex) in sortedRecords[groupIndex].records">
                    <td
                      :key="recordIndex"
                      class="c-table__cell"
                      :class="{
                        'c-table__cell__red': column.id === 'analyse_status' && record.expired,
                        'c-table__cell__yellow': column.id === 'analyse_status' && record.expireSoon,
                      }"
                    >
                      <div class="c-table__cell-value" v-html="record[column.id].value">
                        {{ record[column.id].value }}
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
              <tr
                v-if="data.actions"
                :style="{ height: data.type === 'main-factors' ? '34px' : '' }"
                class="c-table__record"
              >
                <th class="c-table__column">
                  <div class="c-table__column-empty c-table__column-empty-mobile"></div>
                </th>
                <td
                  v-for="(record, recordIndex) in sortedRecords[groupIndex].records"
                  :key="recordIndex"
                  class="c-table__cell"
                >
                  <medical-documents-actions-cell
                    :record="record"
                    :record-id="`mobile-${groupIndex}-${recordIndex}`"
                    @resendAnalyse="$emit('resendAnalyse', record.analyse_id)"
                    @analyseDeleted="$emit('analyseDeleted')"
                  />
                </td>
              </tr>
            </table>
          </perfect-scrollbar>
        </b-collapse>
      </div>
    </div>

    <div v-if="isTableEmpty" class="c-table__empty__records">{{ emptyRecordsLabel }}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MedicalDocumentsActionsCell from "@/pages/personal-employee/additions/data-table/medical-documents-actions-cell";
import Button2 from "@/components/controls2/Button";

export default {
  name: "medical-documents-table",
  components: {
    "c-button-2": Button2,
    MedicalDocumentsActionsCell,
  },
  props: [
    "id",
    "levels",
    "maxWidth",
    "data",
    "enabledFields",
    "disabledColumns",
    "sortedColumn",
    "filteredColumns",
    "activeFilteredColumns",
    "referenceList",
    "emptyRecordsLabel",
    "allGroups",
  ],
  data() {
    return {
      isScrolled: false,
      isScrollEnd: false,
      isScroll: false,
      positionTop: 0,
      filterFieldsBlockHeight: 0,
      filteredColumn: null,
      hideCollapseGroups: [],
      widthMobileTableBody: 0,
      isShowShadowMobileTableHeader: false,
      isShowShadowMobileTableHeaders: {},
    };
  },
  computed: {
    ...mapGetters("app", ["sidebarCollapsed"]),
    sortedRecords() {
      return this.data.records;
    },
    isTableEmpty() {
      return !this.data.records || this.data.records.length === 0;
    },
    displayShadow() {
      return (
        (!(this.data.isGroupByCategory && this.data.records.length !== 0) ||
          !(this.data.isGroupByCategory && this.hideCollapseGroups.length === this.data.records.length)) &&
        this.data.records.length > 0
      );
    },
  },
  watch: {
    enabledFields() {
      this.updatePositionTop();
    },

    disabledColumns(value) {
      const enabledColumns = this.data.columns.filter((item) => !value.includes(item.id));

      const max = Math.max.apply(
        null,
        enabledColumns.map((item) => item.level),
      );

      this.levels = max + 1;

      this.setTableShadow();
    },
  },
  mounted() {
    this.updatePositionTop();

    window.addEventListener("touchend", this.handleTouchMove, {
      passive: false,
    });
    document.querySelector(".layout").addEventListener("scroll", this.handleLayoutScroll);
    document.querySelector(".ps").addEventListener("scroll", this.handleTableScroll);

    if (this.$refs.wrapper) {
      this.isScroll = this.$refs.wrapper.$el.clientWidth < this.$refs.wrapper.$el.scrollWidth;
    }

    setTimeout(() => {
      this.setTableShadow();
    }, 1500);

    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (!isJustShown) {
        if (!this.hideCollapseGroups.includes(collapseId)) this.hideCollapseGroups.push(collapseId);
      } else {
        const c = this.hideCollapseGroups.indexOf(collapseId);
        if (c !== -1) this.hideCollapseGroups.splice(c, 1);
        this.setTableShadow();
      }
    });
  },
  methods: {
    setShadowTableMobile(tableId) {
      const tableMobileFixed = document.getElementById(`tableMobileFixed${tableId}`);
      const tableMobileScroll = document.getElementById(`tableMobileScroll${tableId}`);
      if (tableMobileScroll.scrollLeft > 0) {
        tableMobileFixed.classList.add("c-table__container__mobile__fixed__th__shadow");
      } else {
        tableMobileFixed.classList.remove("c-table__container__mobile__fixed__th__shadow");
      }

      if (tableMobileScroll.scrollLeft < tableMobileScroll.scrollWidth - tableMobileScroll.clientWidth) {
        tableMobileScroll.parentElement.style.position = "relative";
        tableMobileScroll.parentElement.classList.add("c-table__container__mobile__scrolled__td__shadow");
      } else {
        tableMobileScroll.parentElement.classList.remove("c-table__container__mobile__scrolled__td__shadow");
      }
      //
    },

    handleTableScroll() {
      this.setTableShadow();
    },

    handleTouchMove() {
      // if (!e.cancelable) {
      //   e.preventDefault();
      //   return true
      // }
    },

    setTableShadow() {
      if (this.data.actions === undefined) {
        return;
      }
      const ps = document.querySelector(".ps");
      // const tableWrapper = document.querySelector(".c-table__wrapper");
      const tableWrapperShadow = document.querySelector(".c-table__shadow");
      const actionsBlock = document.getElementById("c-table-actions-element");

      if (!ps || !tableWrapperShadow) return;

      const fullScrollWidth = ps.scrollWidth - ps.clientWidth;

      const diff = Math.abs(ps.scrollLeft - fullScrollWidth);

      if (diff > 0 && this.data.records.length !== 0) {
        tableWrapperShadow.classList.add("c-table__shadow_active");
        actionsBlock.classList.add("c-table__column_actions_shadow");
      } else {
        tableWrapperShadow.classList.remove("c-table__shadow_active");
        actionsBlock.classList.remove("c-table__column_actions_shadow");
      }
    },

    resetColumnFilters() {
      this.activeFilteredColumns = [];

      this.$refs.columnFilters.resetFilters();
    },

    isColumnFiltered(columnId) {
      if (this.filteredColumns === undefined) {
        return false;
      }
      const result = this.filteredColumns.findIndex((i) => i === columnId);

      return result !== -1;
    },

    isColumnActiveFiltered(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      return c !== -1;
    },

    setColumnFilter(e) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === e.id);

      const filterOptions = {
        id: e.id,
        type: e.type,
        searchType: e.filter.condition.value,
        value: e.type === "number" && e.filter.condition.value === "4" ? e.filter.rangeValue : e.filter.value,
      };

      if (
        c === -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        return;
      }

      if (
        c !== -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (
        c === -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        return;
      }

      if (
        c !== -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1 && filterOptions.type === "list" && filterOptions.value.length === 0) {
        return;
      }

      if (c !== -1 && filterOptions.value.length === 0) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1) {
        this.activeFilteredColumns.push(filterOptions);
      } else {
        this.activeFilteredColumns.splice(c, 1);
        this.activeFilteredColumns[c] = filterOptions;
      }
    },

    isCategory(column) {
      return column.isCategory === 1;
    },

    isSorted(column) {
      return column.isSorted;
    },

    setSortedColumn(column, sortedColumn) {
      if (
        column.isCategory !== 1 &&
        sortedColumn !== undefined &&
        !(this.data.type === "discipline" && column.id === "explanatory")
      ) {
        const c = this.data.columns.findIndex((i) => i.id === sortedColumn.sortBy);

        if (c !== -1) {
          this.data.columns[c].isSorted = false;
        }

        column.isSorted = true;
        this.sortedColumn.sortBy = column.id;

        if (column.id === sortedColumn.sortBy) {
          this.sortedColumn.sortType = this.sortedColumn.sortType === "asc" ? "desc" : "asc";
        } else {
          this.sortedColumn.sortType = "asc";
        }

        this.$emit("sortedEvent", this.sortedColumn);
      }
    },

    removeColumnFilter(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      if (c !== -1) {
        this.activeFilteredColumns.splice(c, 1);
      }
    },

    openColumnFilterModal(column) {
      const c = this.filteredColumns.findIndex((i) => i === column.id);

      if (c !== -1) {
        this.filteredColumn = column;
      }
    },

    handleLayoutScroll() {
      const layout = document.querySelector(".layout");
      const app = document.querySelector(".app");

      let result = layout.scrollTop - this.positionTop;

      if (app.offsetWidth < 992) {
        result += 50;
      }

      if (layout.scrollTop > this.positionTop) {
        if (
          this.$refs.header &&
          this.data.type !== "inventory-items-history" &&
          this.data.type !== "inventory-items-positions"
        ) {
          this.$refs.header.classList.add("c-table__header-shadow");
          this.$refs.header.style.transform = `translateY(${result}px)`;
        }
      } else if (this.$refs.header) {
        this.$refs.header.classList.remove("c-table__header-shadow");
        this.$refs.header.style.transform = "none";
      }
    },

    updatePositionTop() {
      if (this.$refs.header !== undefined) {
        const header = this.$refs.header.getBoundingClientRect();
        const layout = document.querySelector(".layout");
        this.positionTop = header.top + layout.scrollTop;
      }
    },

    isDefaultCell(record, column) {
      return !this.disabledColumns.includes(column.id);
    },

    getChildrens(columnId) {
      return this.data.columns.filter((item) => item.parentColumnId === columnId);
    },

    getTableColumns(level) {
      let out = [];

      const columns = this.data.columns.filter((item) => item.parentColumnId === undefined);

      if (level === 1) {
        out = out.concat(columns);
      } else if (level === 2) {
        Object.keys(columns).forEach((i) => {
          out = out.concat(this.getChildrens(columns[i].id));
        });
      } else if (level === 3) {
        Object.keys(columns).forEach((i) => {
          const childrens = this.getChildrens(columns[i].id);

          Object.keys(childrens).forEach((ii) => {
            out = out.concat(this.getChildrens(childrens[ii].id));
          });
        });
      }

      return out;
    },

    getColumns(level) {
      let cols = [];

      if (level === 1) {
        cols = this.data.columns.filter((col) => col.parentColumnId === undefined);
      } else if (level === 2) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          cols = cols.concat(childrens);
        });
      } else if (level === 3) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          Object.keys(childrens).forEach((ii) => {
            const childrens2 = this.data.columns.filter((col) => col.parentColumnId === childrens[ii].id);
            cols = cols.concat(childrens2);
          });
        });
      }

      return cols;
    },

    getColspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      let count = children.length;

      if (column.level === 0) {
        Object.keys(children).forEach((c) => {
          const childrenChildren = this.data.columns
            .filter((col) => col.parentColumnId === children[c].id)
            .filter((colChild) => !this.disabledColumns.includes(colChild.id));

          count += childrenChildren.length;
        });
      }

      Object.keys(children).forEach((i) => {
        const result = this.disabledColumns.find((item) => item === children[i].id || children[i].isCategory === 1);

        if (result) {
          count -= 1;
        }
      });

      return count;
    },

    getRowspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      if (this.levels === 3) {
        if (column.level === 0 && children.length === 0) {
          return 3;
        }
        if (column.level === 1 && children.length === 0) {
          return 2;
        }
      } else if (this.levels === 2) {
        if (column.level === 0 && children.length === 0) {
          return 2;
        }
      }

      return 1;
    },

    getSeletItemLabel(record, column) {
      let cell = null;

      if (column.items) {
        const item = column.items.find((i) => i.value === record[column.name]);

        cell = item ? item.label : "-";
      } else {
        cell = "-";
      }

      return cell;
    },

    scroll() {
      // const layout = document.querySelector(".layout");
      // layout.classList.add('layout-touch-action-none');
      const wrapper = this.$refs.wrapper.$el;
      this.isScrolled = this.$refs.wrapper.$el.scrollLeft > 0;
      const containerWidth = this.$refs.container.offsetWidth;
      const wrapperWidth = this.$refs.wrapper.$el.offsetWidth;
      const { scrollLeft } = this.$refs.wrapper.$el;
      this.isScrollEnd = wrapperWidth + scrollLeft >= wrapper.scrollWidth && wrapper.scrollWidth > containerWidth;
      // layout.classList.remove('layout-touch-action-none');
    },

    isDisabled(id) {
      return this.disabledColumns.find((item) => item === id);
    },

    getReferenceValues(e) {
      this.$emit("getReferenceValues", e);
    },

    getCountWorkers(postCode) {
      let countWorkers;
      this.allGroups.forEach((group) => {
        group.categories.forEach((category) => {
          const c = category.posts.findIndex((post) => post.code === postCode);
          if (c !== -1) {
            countWorkers = category.posts[c].countWorkers;
          }
        });
      });
      return countWorkers;
    },

    getAnalyseStatus(analyse) {
      if (analyse.expired) {
        return "Просрочен";
      }

      return "Сдан";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-table {
  position: relative;
  display: inline-block;
  max-width: 100%;

  &__records {
    transition: all ease-in;
    transition-duration: 300ms;
  }

  &__record {
    height: 35px;
    &:focus {
      outline: none;
    }
    &[aria-expanded="true"] .c-table__cell__collapse__button svg {
      transform: rotate(-180deg);
    }
    &[aria-expanded="false"] .c-table__cell__collapse__button {
      border-bottom: none;
    }

    &__red {
      background: #ffe6f2;
    }

    &__yellow {
      background: #fdffb3;
    }
  }

  &__scrollbar-wrapper {
    position: fixed;
    height: 24px;
    background: white;
    box-shadow: $box-shadow;
    bottom: 0;
    left: 0;
    z-index: 100;
    transition: 0.2s;

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    max-width: 100%;
  }

  @media screen and (max-width: 700px) {
    margin: 0 -20px;
    width: calc(100% + 40px);
    max-width: none;
  }

  &__wrapper {
    overflow-x: auto;
    position: relative;
    transition: 0.2s;
    display: inline-block;
    width: 100%;

    &__mobile {
      margin-top: 1px;
      margin-left: -1px;
    }

    &::-webkit-scrollbar {
      height: 0;
    }

    @media screen and (max-width: 992px) {
      width: 100%;
    }

    ::v-deep & .ps__rail-y {
      display: none !important;
    }

    ::v-deep & .ps__rail-x {
      z-index: 351;
      background: #ffffff !important;
    }

    ::v-deep & .ps__rail-x:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-30px, 0);
      box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
      z-index: -1;
      height: 24px;
      width: calc(100vw - 60px);
      background: #ffffff;
    }

    ::v-deep & .ps__rail-x:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(0, calc(-50% + 1px));
      border-radius: 10px;
      z-index: -1;
      height: 4px;
      width: calc(100% - 34px);
      background: #dfe4ef;
    }
  }

  &__shadow {
    position: absolute;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
    width: 10px;
    height: calc(100% - 10px);
    right: 66px;
    opacity: 0;
    bottom: 10px;
    visibility: hidden;
    z-index: 83;
    transition: 0.2s;

    @media screen and (max-width: 700px) {
      background: transparent;
    }

    &__finance {
      right: 40px;
    }

    &__inventory-items-positions {
      right: 166px;
    }

    &__documents {
      right: 100px;
    }
  }

  &__empty__shadow {
    right: 0;
  }

  &__empty__records {
    border: 1px solid $color-border-alt;
    width: calc(100% - 1px);
    height: 40px;
    display: flex;
    margin-top: -8px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: $z-index-loader;
    background: white;
    color: $label;
    font-size: 13px;

    @media screen and (max-width: 700px) {
      width: 100%;
      height: 200px;
      border-left: none;
      border-right: none;
      margin-top: 0;
    }
  }

  &__empty__posts__not__added {
    font-size: 15px;

    @media screen and (max-width: 700px) {
      margin: 0 20px;
    }
  }

  &__shadow_active {
    opacity: 0.15;
    visibility: visible;
  }

  &_scroll {
    .c-table__column_actions {
      &:after {
        visibility: visible !important;
        opacity: 0.15 !important;
      }
    }

    &.c-table_scroll_end {
      .c-table__shadow {
        visibility: hidden;
        opacity: 0;
      }

      .c-table__column_actions {
        &:after {
          visibility: hidden !important;
          opacity: 0 !important;
        }
      }
    }
  }

  &_scrolled {
    border-left: 1px solid $color-border-light;

    //@media screen and (max-width:992px) {
    border-left: none;

    &:before {
      position: absolute;
      content: "";
      width: 22px;
      pointer-events: none;
      height: 100%;
      background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      top: 0;
      left: 0;
      z-index: 100;
    }
    //}
  }

  &_scrolled_right {
    border-left: 1px solid $color-border-light;

    //@media screen and (max-width: 992px) {
    border-left: none;

    &:after {
      position: absolute;
      content: "";
      width: 22px;
      pointer-events: none;
      height: 100%;
      background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      top: 0;
      right: 0;
      z-index: 100;
    }
    //}
  }

  .c-table {
    &__container {
      border-collapse: collapse;
      width: calc(100% - 1px);

      @media screen and (max-width: 700px) {
        display: none;
      }

      &__mobile {
        display: none;
        position: relative;

        @media screen and (max-width: 700px) {
          display: block;
        }

        &__fixed__th td,
        &__fixed__th th,
        &__scrolled__td td,
        &__scrolled__td th {
          background: white;
        }

        &__fixed__th {
          position: absolute;
          & table {
            margin-left: -1px;
          }

          &__shadow {
            &:after {
              content: "";
              position: absolute;
              top: 0;
              left: 82px;
              height: 100%;
              z-index: 10;
              background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
              opacity: 0.15;
              transform: rotate(-180deg);
              width: 10px;
            }
          }
        }

        &__fixed__th th {
          position: relative;
          z-index: 1;
        }

        &__scrolled__td {
          &__shadow {
            &:after {
              position: absolute;
              width: 22px;
              height: 100%;
              pointer-events: none;
              z-index: 1000;
              top: 0;
              right: -1px;
              content: "";
              background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
            }
          }

          & table {
            //min-width: 100%;
            min-width: calc(100% + 2px);
            margin-left: -2px;
          }
          //display: inline-block;
        }
      }
    }

    &__header {
      border-bottom: 2px solid $color-border-light;
      position: relative;
      background: $color-border-light;
      z-index: 82;

      &__mobile {
        display: inline-block;
        width: calc(100% - 1px);
        position: relative;

        &__shadow {
          &:after {
            content: "";
            position: absolute;
            height: 100%;
            top: 0;
            z-index: 100;
            right: -10px;
            width: 10px;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
            opacity: 0.15;
            transform: rotate(-180deg);
          }
        }
      }
    }

    &__header-shadow:after {
      content: "";
      position: absolute;
      background: linear-gradient(#001550, rgba(255, 255, 255, 0));
      width: 100%;
      height: 10px;
      opacity: 0.15;
      z-index: 69;
      bottom: -10px;
      left: 0;
    }

    &__column {
      text-align: left;
      border: 1px solid $color-border-light;
      vertical-align: top;
      height: 35px;
      padding: 0;
      transition: 0.2s;

      &_hidden {
        width: 0;
        border: none;
        overflow: hidden;
        display: none;
        // margin-left: -1px;

        .c-table__column-wrapper {
          width: 0;
          padding: 0;
          border: none;
        }
      }

      &_with {
        &_filter {
          .c-table__column {
            &-wrapper {
              flex-direction: column;
            }

            &-actions {
              margin-top: 10px;
            }
          }
        }
      }

      &_sorted {
        .c-table__column-label {
          color: $color-primary;
        }
      }

      &-label {
        color: $color-label;
        font: {
          size: 12px;
          weight: 500;
        }
        line-height: 13px;

        &-event {
          white-space: nowrap;
        }

        &-mobile {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &-children {
          cursor: pointer;
        }
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 11px;
        height: 100%;
        background: white;

        &-mobile {
          max-width: 83px;
          border-right: 1px solid #dfe4ef;

          & .c-table__column-label {
            display: flex;
            align-items: center;
          }

          &-main-factors {
            padding: 8.5px !important;
          }

          &-finance {
            padding: 8.5px !important;
          }
        }

        @media screen and (max-width: 700px) {
          padding: 10px;
        }
      }

      &-actions {
        display: flex;
        justify-content: space-between;
      }

      &-action {
        width: 14px;
        height: 14px;

        .c-button {
          width: 14px;
          height: 14px;
        }

        &_description {
          margin-left: -3px;
        }
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 30;

        @media screen and (max-width: 700px) {
          border-right: solid 1px $color-border-light;
        }

        &_shadow {
          &:after {
            content: "";
            position: absolute;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
            width: 9px;
            height: 100%;
            left: -8px;
            opacity: 0;
            bottom: 0;
            visibility: hidden;
            z-index: 40;
          }
        }
      }

      &-empty {
        background: white;
        width: calc(100% + 1px);
        height: calc(100% + 2px);
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        border-bottom: 2px solid $color-border-light;
        margin-left: -1px;
        position: relative;

        &-mobile {
          height: calc(100% + 1px);
          border-bottom: 1px solid $color-border-light;
        }
      }

      &__mobile {
        width: 83px;
        min-width: 83px;
        border-right: none;
        overflow-wrap: normal !important;
        //word-break: break-all !important;
      }
    }

    &__cell {
      border: 1px solid $color-border-light;
      padding: 0;
      height: 1px;
      //transition: .2s;

      &__red {
        background: #ffe6f2 !important;
      }

      &__yellow {
        background: #fdffb3 !important;
      }

      &__move__in__company {
        min-width: 200px;
      }

      &__border__none {
        border: none !important;
      }

      &_minShiftDuration {
        text-align: right;
      }

      &_loadType {
        text-align: right;
      }

      &_finesPerShift,
      &_rewardsShift {
        text-align: center;
      }

      &_change {
        & .c-table__cell-value {
          white-space: nowrap;
        }
      }

      &_vertical_align {
        &:first-child {
          vertical-align: top;
        }
      }

      &__collapse__button {
        min-height: 38px;
        vertical-align: middle;
        padding: 0 10px;
        white-space: nowrap;
        background: #f5f7fa;
        overflow: hidden;
        position: relative;
        outline: none;
        border: 1px solid #dfe4ef;
        z-index: 81;
        font-family: Fira Sans;
        font-weight: bold;
        font-size: 13px;
        color: #000000;

        &__docs {
          border-right: 0;

          &:after {
            content: "";
            height: 100%;
            width: 1px;
            background: #dfe4ef;
            position: absolute;
            top: 0;
            right: 0;

            @media screen and (max-width: 700px) {
              display: none;
            }
          }
        }

        @media screen and (max-width: 700px) {
          &[aria-expanded="true"] svg {
            transform: rotate(-180deg);
          }
          &__hide__borders {
            &[aria-expanded="true"] {
              border-bottom: none;
            }
            &[aria-expanded="false"] {
              border-bottom: solid 1px $color-border-light !important;
            }
          }
          &__hide__borders__last {
            border-top: none;
            &[aria-expanded="true"] {
              border-bottom: none !important;
            }
            &[aria-expanded="false"] {
              border-bottom: solid 1px $color-border-light !important;
            }
          }
          border-right: none;
          border-left: none;
        }

        &__icon {
          margin-right: 10px;
        }

        &__category__name {
          display: block;
          @media screen and (max-width: 700px) {
            max-width: 65%;
          }
          max-width: 85%;
        }

        &__category__count {
          line-height: 38px;
          margin-left: 6px;
          color: #8e9cbb;

          @media screen and (max-width: 700px) {
            margin-right: 2px;
          }
        }

        &-wrapper {
          display: flex;
          align-items: center;
          white-space: normal;
        }

        &__button {
          vertical-align: middle;
          display: inline-block;
          margin-left: 3px;
        }

        @media screen and (max-width: 767px) {
          &__border__right {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            width: 1px;
            background: #dfe4ef;
          }
        }
      }

      &_number {
        & .c-table__cell-value {
          text-align: right;
        }
      }

      &_rank {
        & .c-table__cell-value {
          text-align: left;
        }
      }

      &_hidden {
        width: 0;
        overflow: hidden;
        border: none;
        display: none;

        .c-table__cell-value,
        .c-table__cell-cell {
          width: 0;
          padding: 0;
        }
      }

      &-cell {
        display: flex;
        align-items: center;
        transition: 0.2s;
      }

      &-value {
        line-height: 13px;
        font-size: 13px;
        padding: 10px !important;
        transition: font 0.3s ease;

        &-nowrap {
          white-space: nowrap !important;
        }
      }

      &-values {
        padding: 0;
        line-height: 13px;
        font-size: 13px;
        transition: font 0.3s ease;
        white-space: nowrap !important;

        ::v-deep & .c-table__cell-values-value {
          background: red;
        }
      }

      &-pre-formatted {
        white-space: pre;
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 20;

        @media screen and (max-width: 700px) {
          position: static;
        }
      }

      &-actions {
        width: calc(100% + 1px);
        min-height: 30px;
        height: 100%;
        display: flex;
        align-items: center;
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        margin-left: -1px;

        &-collapse-button {
          border-left: 0;
        }
      }
    }
  }
}

::v-deep .collapsing {
  transition: font 0.5s ease;
}

::v-deep .collapse {
  display: table-row;
}

::v-deep .collapse.c-table__mobile__collapse {
  display: block;
}

::v-deep .collapsed ~ .collapse {
  max-height: 0 !important;

  & .c-table__cell {
    border: 0 !important;
    height: 0 !important;
    max-height: 0 !important;
  }

  & .c-table__cell .inventory-item-actions {
    display: none !important;
  }

  & .c-table__cell .documents-files-cell {
    display: none !important;
  }

  & .c-table__column {
    border: 0 !important;
    height: 0 !important;
    max-height: 0 !important;
  }

  & .c-table__column .c-table__column-wrapper {
    padding: 0 !important;
    border-right: 0 !important;
    max-height: 0 !important;
    height: 0 !important;
  }

  & .c-table__column .c-table__column-empty-mobile {
    border: none;
    max-height: 0 !important;
  }

  & .c-table__column .c-table__column-wrapper .c-table__column-label {
    font-size: 0 !important;
  }

  & .c-table__cell .c-table__cell-value {
    color: #ffffff !important;
    line-height: 0 !important;
    padding: 0 !important;
    font-size: 0;
    transition: font 0.3s ease;
  }

  & .c-table__cell .documents-actions {
    display: none;
  }

  & .c-table__cell .cell-filial-settings {
    visibility: hidden !important;
    height: 0 !important;
    max-height: 0 !important;
    padding: 0 !important;
    font-size: 0 !important;

    & .cell-filial-settings__value {
      font-size: 0;
      line-height: 0;
    }

    & .cell-filial-settings__icon {
      display: none;
    }
  }

  & .c-table__cell_actions .c-table__cell-actions {
    display: none;
  }

  & .c-table__header__mobile {
    max-height: 0 !important;
  }
  & .c-table__header__mobile tr {
    max-height: 0 !important;
  }

  & .c-table__header__mobile tr .c-table__column {
    border: 0 !important;
    height: 0 !important;
    font-size: 0 !important;
    max-height: 0 !important;
  }

  & .c-table__header__mobile tr .c-table__column .c-table__column-wrapper {
    display: none;
    padding: 0 !important;
  }

  & .c-table__header__mobile tr .c-table__column .c-table__column-label {
    font-size: 0 !important;
    line-height: 0 !important;
  }
}
</style>

<style lang="scss">
.c-table__cell-values {
  @media screen and (max-width: 700px) {
    display: flex;
  }
  &-value {
    padding: 10px;
    border-bottom: solid 1px #dfe4ef;

    @media screen and (max-width: 700px) {
      border-bottom: none;
      border-right: solid 1px #dfe4ef;
    }
  }
  &-value-not-border {
    padding: 10px;
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
